import React, { Component } from 'react';
import PropTypes from 'prop-types';
import { DFPSlotsProvider, AdSlot } from 'react-dfp';
import {HashRouter, Route} from 'react-router-dom';
import { ConnectedRouter } from 'react-router-redux';
import { Provider } from 'react-redux';
import App from './App';
import withTracker from './withTracker';
import ScrollToTop from './ScrollToTop';

export default class Root extends Component {
  render() {
    const { store, history } = this.props;

    return (
      <Provider store={store}>
        <DFPSlotsProvider dfpNetworkId='15308329' targetingArguments={{}}>
          <ConnectedRouter history={history}>
            <HashRouter>
              <ScrollToTop>
                <Route component={withTracker(App)} />
              </ScrollToTop>
            </HashRouter>
          </ConnectedRouter>
        </DFPSlotsProvider>
      </Provider>
    );
  }
}

Root.propTypes = {
  store: PropTypes.object.isRequired,
  history: PropTypes.object.isRequired
};



// WEBPACK FOOTER //
// ./src/components/Root.js